import {
    DESTROY_TOKEN,
    SET_ACCESS_TOKEN,
    SET_OAUTH_SERVICES,
    SET_REGISTER_SIGNATURE
} from "@/core/store/modules/auth/constants";
import storage from "@/core/services/storage.service";
import api from "@/core/services/api/api.service"

export default {
    [SET_ACCESS_TOKEN](state, accessToken) {
        state.accessToken = accessToken;
     },
    [DESTROY_TOKEN](state) {
        api.removeAuthorizationHeader();
        state.accessToken = null;
     },
    [SET_OAUTH_SERVICES](state, services) {
        state.oauthServicesBooted = true
        state.oauthServices = services;
    },
    [SET_REGISTER_SIGNATURE](state,signature){
        state.signature = signature;
    }
}
